<div
  class="top-banner-shell"
  [class.top-banner-shell--info]="variant === 'info'"
  [class.top-banner-shell--warning]="variant === 'warning'">
  <div class="top-banner-shell__inner">
    <ng-content />
  </div>
</div>
